import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-w3w',
  templateUrl: './w3w.component.html',
  styleUrls: ['./w3w.component.scss']
})
export class W3wComponent implements OnInit {

  w3w: any;
  account: any;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getAccount();

  }



  getAccount(){

    this.okService.get("account",[])
    .subscribe((data) => {

      this.account = data.body;

      //console.log("account",this.account);

    })
  }

  toggleEnabled(account:any){

    account.w3w = + !account.w3w;

    this.okService.put('account',{'w3w':account.w3w})
    .subscribe((data) => {
      //console.log("toggle w3w",data)
      }
    );
  }
}
